<template>
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"
    :table-items="storageItems"
    :indexNested="true"
    :maskFields="maskFields"
    :disablePagination="true"
    :hasTableTitle="hasTableTitle"
    :tableTitle="tableTitle"
    :showExpand="true"
    :customExpandIcon="true"
    @row-clicked="handleRowClicked"
    class="row-pointer"
    :containSearchBar="false"
  >
   

    <template v-slot:expand="{ item, headers }" v-if="this.enabledLots">
      <td :colspan="headers.length" :class="'px-0 px-sm-2 px-md-6 mt-3 ' + ($vuetify.breakpoint.smAndDown ? 'v-data-table__mobile-row': '')">
        <StorageItemLotIndex
          v-if="true"          
          :hasTableTitle="true"
          :hasTopMenu="false"
          :loading="false"
          :storageItemLots.sync="item.storageItemLots"          
          class="mt-6"                   
          :readOnly="readOnly"          
        />
      </td>
     
    </template>

    <template v-slot:expandColumn="{ item, isExpanded, expand }" v-if="this.enabledLots">
      <v-btn text color="primary" v-if="!isExpanded">Ver Lotes</v-btn>
      <v-btn text color="primary" v-if="isExpanded"><v-icon left>mdi-eye-off</v-icon>Lotes</v-btn>
    </template>

    <template slot="tableFooter">
      <tr class="d-none d-md-table-row">
        <td colspan="5"><strong class="title">Total dos Itens</strong></td>
        <td colspan="1" class="text-xs-right title"><strong>{{ this.storageItemsTotalPrice | formatCurrency }}</strong></td>
      </tr>

      <!-- for mobile only -->
      <tr class="d-table-row d-md-none v-data-table__mobile-table-row">
        <td class="v-data-table__mobile-row">
          <div class="v-data-table__mobile-row__header">Total dos Itens</div>
          <div class="v-data-table__mobile-row__cell"><strong>{{ this.storageItemsTotalPrice | formatCurrency }}</strong></div>
        </td>
      </tr>
    </template>

  </BaseIndex>
</template>

<script>
import BaseIndex from "@shared_components/base_index.vue";
import StorageItemLotIndex from "@models/storages/storage_items/storage_item_lots/index.vue"

export default {
  data() {
    return {
      loading: false,
      pageLoading: false,
      indexKey: 1,
      // tableHeaders: [],
      maskFields: [
        { field: 'averageUnitPrice', mask: 'currency_10d' }, 
        // { field: 'purchaseQuantity', mask: 'number'},
        { field: 'availableQuantity', mask: 'number'}, 
        { field: 'packagingQuantity', mask: 'number'}, 
        { field: 'movementItemAvailableQuantity', mask: 'number'},
        // { field: 'totalPrice',mask: 'currency'},
        { field: 'availableTotalPrice', mask: 'currency' }
      ]
    };
  },
  components: {
    BaseIndex: BaseIndex,
    StorageItemLotIndex: StorageItemLotIndex,    
  },
  props: {
    storageItems: {
      type: Array,
      default: () => [],
    },
    storageItemsTotalPrice: {
      type: Number,
      default: 0
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    hasLots: {
      type: Boolean,
      default: false,
    },
    enabledLots: {
      type: Boolean,
      default: false,
    },    
    hasTableTitle: {
      type: Boolean,
      default: false
    },
    tableTitle: {
      type: String
    },
    modelNameSingular: {
      type: String,
      default: "Item de Estoque"
    },
    modelNamePlural: {
      type: String,
      default: "Itens de Estoque"
    },
  },
  created() {
  },
  computed: {
    tableHeaders() {
      var indexTable = [
        { text: "Item", align: "left", sortable: true, value: "item.name" },
          { text: "Embalagem", align: "left", sortable: true, value: "packaging.name" },
          { text: "R$ Médio", align: "left", sortable: true, value: "averageUnitPrice" },
          { text: "Qtd. Disponível", align: "left", sortable: true, value: "availableQuantity" }, 
          { text: "Qtd. Emb", align: "left", sortable: true, value: "packagingQuantity" },
          // ... this.objectType == "StockItem" ? [{ text: "Qtd. Disponível", align: "left", sortable: true, value: "availableQuantity" }] : [{ text: "Qtd.", align: "left", sortable: true, value: "purchaseQuantity" }],
          // { text: "Und.", align: "left", sortable: true, value: "packaging.unit.name" },
          { text: "R$ Total", align: "left", sortable: true, value: "availableTotalPrice" },
      ];
      // console.log("enabled", this.enabledLots);
        if (this.enabledLots){          
          indexTable.push({ text: "Lotes", value: "data-table-expand", sortable: false },);
        }      
        return indexTable;
    }
  },
  methods: {
    entryUpdated: function(editedStorageItem){
      this.$refs.baseIndex.showConfirmationUpdateMessage();
      // this.recalculatePurchaseTotalPrice();
    },
    entryCreated: function(newStorageItem){
      this.storageItems.push(newStorageItem);
      this.$refs.baseIndex.showConfirmationCreateMessage();
      // this.recalculatePurchaseTotalPrice();
    },
    entryDeleted: function(deletedStorageItem){
      this.$refs.baseIndex.showConfirmationDeleteMessage();
      // this.recalculatePurchaseTotalPrice();
    },
    handleRowClicked: function(rowArguments) {
      // console.log("row click", rowArguments);
      if (rowArguments && rowArguments[1]) {
        rowArguments[1].expand(!rowArguments[1].isExpanded);
      }
    }
    // recalculatePurchaseTotalPrice: function() {
    //   var newPurchaseTotalPrice = 0;
    //   for (var purchase in this.purchaseItems) {
    //     if(!this.purchaseItems[purchase]._destroy) {
    //       if (this.objectType != "StockItem") {
    //         newPurchaseTotalPrice += this.purchaseItems[purchase].totalPrice;
    //       } else {
    //         newPurchaseTotalPrice += this.purchaseItems[purchase].availableTotalPrice;
    //       }
    //     }
    //   }
    //   newPurchaseTotalPrice = _.round(newPurchaseTotalPrice, 2);
    //   this.$emit('update:purchaseTotalPrice', newPurchaseTotalPrice);
    // }
  }
};
</script>

<style lang="css" scoped>
  .row-pointer >>> tbody tr :hover {
    cursor: pointer;
  }
</style>
